module.exports = __webpack_public_path__ + "img/servetwo.80944cfb.png";